"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function getRatingType(ratingValue, index) {
  if (ratingValue >= index) {
    var integer = Math.floor(ratingValue);
    var double = ratingValue - integer;

    if (index === integer && double >= 0.3 - Number.EPSILON && double <= 0.6 - Number.EPSILON) {
      return 'half';
    }

    if (ratingValue > index + 0.6) {
      return 'full';
    }
  }

  return 'empty';
}

exports.default = getRatingType;